<template>
  <div class="order-details orderDetails" ref="container">
    <div class="receiveInfo">
      <p class="cusInfo">
        <!-- <img src="@assets/images/logo2.png" /> -->
        <span class="customer">{{ orderInfo.customer_name }}</span>
        <span class="customer ml-20">{{ orderInfo.customer_phone }}</span>
      </p>
      <p>
        <span>{{ orderInfo.consignee_name }}</span>
        <span class="ml-20">{{ orderInfo.consignee_phone }}</span>
      </p>
      <p class="address">
        <span>地址：</span>
        {{ orderInfo.consignee_address }}
      </p>
      <div class="line">
        <img src="@assets/images/line.jpg" />
      </div>
    </div>
    <div class="infoBox mt-10">
      <p class="pro-count padding20 bor-b">
        <span>spu数：{{ orderInfo.total_spu }}</span>
        <span>sku数：{{ orderInfo.total_sku }}</span>
        <span>商品数：{{ orderInfo.total_num }}</span>
      </p>
      <ul class="proList pad20">
        <li
          class="proItem"
          v-for="(pro, index) in orderInfo.detail"
          :key="index"
        >
          <van-row class="bor-b pro-info">
            <van-col class="baseInfo" span="24">
              <p class="bor-b">
                <span>{{ index / 1 + 1 }}</span>
                <a class="pro-name">
                  <span>{{ pro.product_name }}</span>
                  <span>{{ pro.colour }}</span>
                </a>
              </p>
              <p class="font-size-14">
                <a class="font-gray">
                  单价：¥
                  <span>{{ pro.price * 1 }}</span>
                </a>
                <a class="font-gray">
                  数量(双)：
                  <span>{{ pro.number }}</span>
                </a>
                <a class="font-gray">
                  金额：¥
                  <span>{{ pro.total * 1 }}</span>
                </a>
              </p>
            </van-col>
          </van-row>
          <van-row class="size-info" v-for="item in pro.item" :key="item.sku">
            <van-col span="3">
              <p style="height: 40px; line-height: 40px" class="bor-c">
                <img :src="pro.image" object-fit="cover" alt />
              </p>
            </van-col>
            <van-col span="21">
              <van-row class="bor-b bg-gray">
                <van-col span="12">
                  <p>尺码</p>
                </van-col>
                <van-col span="12">
                  <p>售后数量</p>
                </van-col>
              </van-row>
              <van-row>
                <van-col span="12" class="bg-gray">
                  <p>{{ item.size }}</p>
                </van-col>
                <van-col span="12">
                  <p>{{ item.num }}</p>
                </van-col>
              </van-row>
            </van-col>
          </van-row>
        </li>
      </ul>
    </div>
    <div class="infoBox mt-10">
      <van-cell
        :border="false"
        title="订单编号："
        v-model="orderInfo.sn"
      ></van-cell>
      <van-cell
        :border="false"
        title="订单日期："
        v-model="orderInfo.create_time"
      ></van-cell>
      <van-cell
        :border="false"
        title="售后类型："
        v-model="orderInfo.type_sn"
      ></van-cell>
      <van-cell
        :border="false"
        title="订单状态："
        v-model="orderStatus[orderInfo.status]"
      ></van-cell>
      <van-cell
        :border="false"
        title="客户备注："
        v-model="orderInfo.user_mark"
      ></van-cell>
      <!-- <van-cell style="color: #969799" title="客户备注客户备注客户备注"></van-cell> -->
      <van-cell
        :border="false"
        title="物流公司："
        v-model="orderInfo.freight_name"
      ></van-cell>
      <van-cell
        title="物流备注："
        v-model="orderInfo.freight_remarks"
      ></van-cell>
    </div>
    <div class="infoBox mt-10">
      <van-cell
        :border="false"
        title="商品金额："
        v-model="orderInfo.total_price"
      ></van-cell>
      <!-- <van-cell :border="false" title="物流费用：" v-model="orderInfo.freight_price"></van-cell>
      <van-cell :border="false" title=" ">
        <template solt="extra">
          <p>
            实付款：
            <span 
              class="realPay"
            >{{orderInfo.total_price/1 + orderInfo.freight_price/1}}</span>
          </p>
        </template>
      </van-cell> -->
    </div>
  </div>
</template>
<script>
import { getServiceDetail } from "@api/order";
import { formatPrice } from "@utils";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      sizeList: [{}],
      orderInfo: {
        addr_id: "",
        consignee_address: "",
        consignee_name: "",
        consignee_phone: "",
        create_time: "",
        customer_id: "",
        customer_mark: null,
        customer_name: "",
        customer_phone: "",
        detail: [],
        freight_name: "",
        freight_pay_price: null,
        freight_pay_status: null,
        freight_price: ".00",
        freight_remarks: "",
        id: "",
        pay_time: null,
        pay_type: "0",
        return_amount: null,
        sn: "",
        status: "0",
        total_num: "0",
        total_price: "0.00",
        total_sku: "",
        total_spu: "",
        type_sn: "",
        updateTime: null,
        user_mark: null
      },
      orderStatus: {
        0: "受理中",
        1: "已受理"
      },
      orderAfterId: "",
      isShow: 2
    };
  },
  created() {
    if (this.$route.query && this.$route.query.orderAfterId) {
      this.orderAfterId = this.$route.query.orderAfterId;
      //   this.isShow = this.$route.params.isShow;
      console.log(this.$route.query);
      // this.getOrderDetal();
    }
    this.getOrderDetal();
  },
  methods: {
    formdate(date) {
      var unixTimestamp = new Date(date * 1000);
      var commonTime = unixTimestamp.toLocaleString();
      var s = commonTime.toLocaleString();
      var ss = s.replace(/年|月/g, "-").replace(/日/g, " ");
      return ss;
    },
    getOrderDetal() {
      const { orderAfterId, isShow } = this;
      getServiceDetail({ orderAfterId, isShow })
        .then(res => {
          formatPrice(res.data);
          console.log(res.data);
          this.orderInfo = res.data;
          this.orderInfo.create_time = this.formdate(res.data.create_time);
        })
        .catch(e => {
          console.log(e);
          // this.orderInfo = e.data.data;
        });
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  }
};
</script>
